import React from 'react';
import { Link } from 'react-router-dom';
import SEO from '../components/SEO';
import './Products.css';

const Products = () => {
  const productsList = [
    {
      title: 'Corrugated Packaging',
      description: 'Sustainable, Customizable TSW Corrugated Box Solutions Designed to Fit Your Unique Packaging',
      image: '/images/product/download (1).jpg',
      link: '/products/corrugated-boxes'
    },
    {
      title: 'Strapping System',
      description: 'Ideal for versatility and cost-efficiency, plastic strapping offers high-performance bundling without compromising on safety or speed.',
      image: '/images/product/Polyester (PET).png',
      link: '/products/strapping-solutions'
    },
    {
      title: 'Wrapping System',
      description: 'Protect Against Dust & Moisture During Transit with Signode Complete Wrapping Solutions.',
      image: '/images/product/Pallet Wrapping Machines.png',
      link: '/products/wrapping-solutions'
    },
    {
      title: 'Protective Packaging',
      description: 'Protect fragile items and Increase load caring capacity for Optimized Safety of Sensitive and Heavy Items.',
      image: '/images/product/cross_lashing_resized_1000x700.png',
      link: '/products/protective-packaging'
    },
    {
      title: 'Rust Preventions',
      description: 'Zavenir Daubert- Metal cutting, cleaning, and corrosion protection with VCI packaging to prevent rust and extend product life.',
      image: '/images/product/x-clean (1).png',
      link: '/products/rust-prevention'
    }
  ];

  return (
    <div className="products-page">
      <SEO
        title="Packaging Products"
        description="Explore Tirupati Enterprises' full range of packaging products — corrugated boxes, strapping, wrapping, taping, protective packaging, and innovative cushioning solutions."
        path="/products"
      />
      {/* Hero Section */}
      <section className="products-hero">
        <div className="products-hero-overlay"></div>
        <div className="container">
          <h1 className="products-hero-title">Products & Solutions</h1>
        </div>
      </section>

      {/* Page Title */}
      <section className="products-intro">
        <div className="container">
          <h2 className="products-main-title">Tirupati Enterprises End To End Industrial Packaging Solutions</h2>
        </div>
      </section>

      {/* Products Grid */}
      <section className="products-listing">
        <div className="container">
          <div className="products-grid">
            {productsList.map((product, index) => (
              <div key={index} className="product-item">
                <div className="product-item-content">
                  <div className="product-item-text">
                    <h3 className="product-item-title">{product.title}</h3>
                    <p className="product-item-desc">{product.description}</p>
                  </div>
                  <div className="product-item-image">
                    <img 
                      src={product.image} 
                      alt={product.title}
                    />
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="products-cta">
        <div className="container">
          <div className="products-cta-content">
            <h2>Need Custom Packaging Solutions?</h2>
            <p>Contact us to discuss your specific requirements and get a tailored solution for your business.</p>
            <Link to="/contact" className="btn btn-primary-white">
              Get In Touch
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Products;